import { initializeApp } from 'firebase/app'
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase-Web-Konfiguration. Diese Keys sind NICHT geheim (sie identifizieren
// nur das Projekt), der eigentliche Schutz liegt in den Firestore Security Rules.
// Werte können per .env (VUE_APP_FIREBASE_*) für Staging/Prod überschrieben
// werden; ohne .env greifen die hier hinterlegten Produktions-Fallbacks.
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY || "AIzaSyCHyhxq51htOUik7MGHxDRk55QJcCWN7mk",
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || "rpg-troll.firebaseapp.com",
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || "rpg-troll",
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || "rpg-troll.appspot.com",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || "228686025942",
  appId: process.env.VUE_APP_FIREBASE_APP_ID || "1:228686025942:web:748e52633aa8e86a1e6577"
}

const app = initializeApp(firebaseConfig)
const storage = getStorage(app)
const auth = getAuth(app)
const db = getFirestore(app)
export { storage, auth, db }
